/**
 * 进入页面即执行的逻辑代码
 */

import { useConfigStoreWithOut } from '@/store/modules/config'
import { initTheme } from '@/hooks/system/useTheme'

/** 设置网站基本信息 */
function setWebsite() {
  const useConfig = useConfigStoreWithOut()
  useConfig.setBaseWebsite()
}

initTheme()
setWebsite()
